// Date-only strings ("2026-11-01") MUST be parsed as LOCAL midnight.
// `new Date("2026-11-01")` is UTC midnight, which renders as Oct 31 for
// anyone west of Greenwich (our US clients) — prod bug on /pay links,
// 2026-10-05. Full ISO datetimes keep their own offset and pass through.
export const parseDate = (v) => {
  if (v instanceof Date) return v;
  if (typeof v === "string") {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v.trim());
    if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  }
  return new Date(v);
};
